import React, { memo } from 'react';
import PropTypes from 'prop-types';
import Flex from 'components/common/Flex';
import { Nav } from 'react-bootstrap';
import LastMessage from './LastMessage';
import dayjs from 'dayjs';

const ChatThread = ({ thread, index }) => {
  const messages = thread.messages;
  const lastMessage = messages?.[0];
  const newChat = !lastMessage?.question;

  return (
    <Nav.Link
      eventKey={index}
      className='chat-contact hover-actions-trigger p-3 read-message'
    >
      <Flex>
        <div className="flex-1 chat-contact-body ms-2 d-md-none d-lg-block">
          <Flex justifyContent="between">
            <span className="message-time fs--2">
              {' '}
              {newChat ? '' : dayjs(lastMessage?.createdDate).format('ddd D MMM YYYY HH:mm:ss')}{' '}
            </span>
          </Flex>
          <div className="min-w-0">
            <div className="chat-contact-content pe-3">
              <LastMessage lastMessage={newChat ? { question: '<i>New Chat<i>' } : lastMessage} />
              <div className="position-absolute bottom-0 end-0 hover-hide">
              </div>
            </div>
          </div>
        </div>
      </Flex>
    </Nav.Link>
  );
};

ChatThread.propTypes = {
  thread: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired
};

export default memo(ChatThread);
